import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Menu, Select, Spin, Popover, Tabs, Button, Card } from "antd";
import { Link, useHistory, useLocation } from "react-router-dom";
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { useContext } from 'react';
import { CommonContext, CurrencyContext } from '../../Context';
import { getBuyerNameById, getMenuItemIcon } from '../../globalFunctions/GlobalFunctions';
import Topup from './TopUp';
import LandingPage from '../social/LandingPage';

const { Sider } = Layout;

const isTruthy = (value) => value === true || value === 'true';
const clickReportPaths = new Set(['/click-report', '/multi-click-report']);
const getVisibleBuyerMenuItems = (menuItems, canShowClicksReport) =>
  menuItems.filter(
    (item) => canShowClicksReport || !clickReportPaths.has(item.pageURL)
  );

const Sidemenu = () => {
  const currencyContext=useContext(CurrencyContext);
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [buyerList, setBuyerList] = useState([]);
  const [showAppReports, setShowAppReports] = useState(false);
  const [showClicksReport, setShowClicksReport] = useState(false);
  const [showSubBuyerAdmin, setShowSubBuyerAdmin] = useState(null);
  const [showQualityFilter, setShowQualityFilter] = useState(false);
  const [showBoostFiance,setShowBoostFinance]=useState(isTruthy(Cookies.get(constants.COOKIE_IS_FINANCE)));
  const [isCSAdmin,setIsCSAdmin]=useState(isTruthy(Cookies.get(constants.COOKIE_IS_CS_ADMIN)));
  const history = useHistory();
  const location = useLocation();
  const isRecruiter = isTruthy(Cookies.get(constants.COOKIE_IS_RECRUITER));
  const [selfService,setSelfService]=useState(false);
  const isSelfService = isTruthy(sessionStorage.getItem('isSelfService'));
  const [isHIAdmin,setIsHIAdmin]=useState(false);
  const [isHIAdminUser,setIsHIAdminUser]=useState(false);
  const [loader,setLoader]=useState(false);
  const [openPopover, setOpenPopover]=useState(false);
  const [isTopupOpen, setIsTopupOpen] = useState(false);
  const [buyerMenuItems, setBuyerMenuItems] = useState([]);
const [isJobtrainParser, setIsJobtrainParser] = useState(false);
  const isAdminUser = isTruthy(Cookies.get(constants.COOKIE_IS_ADMIN));
  const isCandidateTabEnabled = isTruthy(Cookies.get(constants.COOKIE_CANDIDATE_TAB));
  const showBuyerAdminMenu = Boolean(showSubBuyerAdmin);
  const showSelfServiceMenu = isSelfService || selfService;
  const showRecruiterMenu = isRecruiter;
  const visibleBuyerMenuItems = useMemo(
    () => getVisibleBuyerMenuItems(buyerMenuItems, isTruthy(showClicksReport)),
    [buyerMenuItems, showClicksReport]
  );
  const selectedMenuItem =
    visibleBuyerMenuItems.find((item) => item.pageURL === location.pathname) ||
    visibleBuyerMenuItems[0];
  useEffect(() => {
    const firstMenuItem = visibleBuyerMenuItems[0];
    const isDefaultLandingPath = location.pathname === '/';

    if (isDefaultLandingPath && firstMenuItem?.pageURL) {
      history.replace(firstMenuItem.pageURL);
    }
  }, [visibleBuyerMenuItems, history, location.pathname]);

  useEffect(() => {
    const initializeBuyer = async () => {
      const selectedBuyerId = await BuyerListFetch();
      await getBuyerDetails(selectedBuyerId);
      await fetchBuyerMenuItems(selectedBuyerId);
    };
    initializeBuyer();
  }, []);
  //fetch top menu buyer list
  const BuyerListFetch = async () => {
    let buyerListResponse = [];
    const loggedInBuyerId = Cookies.get(constants.COOKIE_LOGGED_BUYER_ID);
    const isHireIntelligenceUser = Cookies.get(constants.COOKIE_HIRE_INTELLIGENCE_USER) === 'true';
    const response = await APIUtils.apiCall('GET', WebLinks.SubBuyerList + Cookies.get(constants.COOKIE_LOGGED_BUYER_ID));
    if (!response.isCatch && response.resultObj?.statusCode === "2000") {
      buyerListResponse = response.resultObj?.data
        ?.filter((item) => !isHireIntelligenceUser || String(item.subPartnerId) !== String(loggedInBuyerId))
        ?.map((item) => {
        return { 
          selfPost: item.selfPost, 
          value: item.subPartnerId, 
          label: getBuyerNameById(item.subPartnerId, item.name), 
          emailPost: item.emailPost, 
          subBuyerAdmin: item.subBuyerAdmin 
        }
      })
    }
    if (!isHireIntelligenceUser) {
      buyerListResponse = [{
        selfPost: Cookies.get(constants.COOKIE_LOGGED_BUYER_SELF_POSTED),
        value: parseInt(loggedInBuyerId),
        //label: Cookies.get(constants.COOKIE_LOGGED_BUYER_NAME),
        label: getBuyerNameById(loggedInBuyerId, Cookies.get(constants.COOKIE_LOGGED_BUYER_NAME)),
        emailPost: sessionStorage.getItem("emailpost"),
        subBuyerAdmin: Cookies.get(constants.COOKIE_LOGGEDIN_IS_SUB_BUYER_ADMIN)?.toString() === 'true'
      }, ...buyerListResponse];
    }
    buyerListResponse.sort((a, b) => a.label.localeCompare(b.label));
    setBuyerList(buyerListResponse);
    let selectedBuyerId = buyerId;
    const selectedBuyerIsAvailable = buyerListResponse.some(
      (buyer) => String(buyer.value) === String(buyerId)
    );
    if (isHireIntelligenceUser && buyerListResponse.length > 0 && !selectedBuyerIsAvailable) {
      const defaultBuyer = buyerListResponse[0];
      selectedBuyerId = defaultBuyer.value;
      commonContext.changeCommonValues({'buyerId': selectedBuyerId});
      sessionStorage.setItem('common', JSON.stringify({
        ...commonContext.common,
        buyerId: selectedBuyerId
      }));
      await sessionStorage.setItem('selectedbuyerselfpost', defaultBuyer.selfPost);
      await sessionStorage.setItem('selectedbuyername', defaultBuyer.label);
      await sessionStorage.setItem('emailpost', defaultBuyer.emailPost);
      await sessionStorage.setItem('selectedissubbuyeradmin', defaultBuyer.subBuyerAdmin);
    } else if (isHireIntelligenceUser) {
      selectedBuyerId = buyerListResponse.find(
        (buyer) => String(buyer.value) === String(buyerId)
      )?.value ?? buyerId;
    }
    let loggedInBuyer=Cookies.get(constants.COOKIE_LOGGED_BUYER_NAME)?.toLowerCase();
    let SelectedBuyer=sessionStorage.getItem("selectedbuyername")?.toLowerCase();
    setIsHIAdmin(loggedInBuyer?.includes("hi admin")&&loggedInBuyer===SelectedBuyer);
    setIsHIAdminUser(loggedInBuyer?.includes("hi admin"));
    return selectedBuyerId;
  };
  const fetchBuyerMenuItems = async (selectedBuyerId = buyerId) => {
    const loggedInBuyerId = Cookies.get(constants.COOKIE_LOGGED_BUYER_ID);
    const menuResponse = await APIUtils.apiCall('GET', `${WebLinks.GetBuyerMenu}${loggedInBuyerId}&selectedBuyerId=${selectedBuyerId}`);

    if (!menuResponse.isCatch && menuResponse.resultObj?.statusCode === '2000') {
      const menuData = Array.isArray(menuResponse.resultObj?.data)
        ? [...menuResponse.resultObj.data].sort((a, b) => (a.menuOrder ?? 999) - (b.menuOrder ?? 999))
        : [];
      setBuyerMenuItems(menuData);
      return menuData;
    }

    setBuyerMenuItems([]);
    return [];
  };

  const BuyerChanged = async (value) => {
    commonContext.changeCommonValues({'buyerId':value});
    sessionStorage.setItem('common', JSON.stringify({
      ...commonContext.common,
      buyerId: value
    }));
    let buyerDetails = buyerList.find((item) => item.value === value);
    await sessionStorage.setItem('selectedbuyerselfpost', buyerDetails?.selfPost);
    await sessionStorage.setItem('selectedbuyername', buyerDetails?.label);
    await sessionStorage.setItem('emailpost', buyerDetails?.emailPost);
    await sessionStorage.setItem('selectedissubbuyeradmin', buyerDetails?.subBuyerAdmin);
    const menuItems = await fetchBuyerMenuItems(value);
    const firstMenuItem = getVisibleBuyerMenuItems(
      menuItems,
      isTruthy(showClicksReport)
    )[0];
    if (firstMenuItem?.pageURL) {
      history.replace(firstMenuItem.pageURL);
    }
    //reload the page to refresh buyer details on the open menu item eg. application report list
    window.location.reload();
  };
  const getBuyerDetails = async (selectedBuyerId = buyerId) => {
    setLoader(true);
    const response = await APIUtils.apiCall('GET', WebLinks.GetBuyerDetails + selectedBuyerId);
    if (!response.isCatch && response.resultObj?.statusCode === "2000") {
      currencyContext.changeCurrencyValue(constants.CurrencyConstants[response.resultObj?.data?.cpaCurrency||"GBP"])
      await commonContext.changeCommonValues({'boostCredits':response.resultObj?.data?.boostCredits||0});
      setShowClicksReport(response.resultObj?.data?.clickPost);
      setShowAppReports(response.resultObj?.data?.showAppReports);
      setShowSubBuyerAdmin(response.resultObj?.data?.subBuyerAdmin);
      setShowQualityFilter(response.resultObj?.data?.manualQualityReview);
      setSelfService(response.resultObj?.data?.selfService);
      //setShowBoostFinance(response.resultObj?.data?.hireIntelligenceFinance )
      await sessionStorage.setItem('isSelfService', response.resultObj?.data?.selfService);
      await sessionStorage.setItem('isBoost', response.resultObj?.data?.showBoost);
      await sessionStorage.setItem('clickPost', response.resultObj?.data?.clickPost);
      await sessionStorage.setItem('allowCreditInvoicing', response.resultObj?.data?.allowCreditInvoicing);
      await Cookies.set(constants.COOKIE_ALLOW_CREDIT_INVOICE, response.resultObj?.data?.allowCreditInvoicing);
      await sessionStorage.setItem('selectedissubbuyeradmin', response.resultObj?.data?.subBuyerAdmin);
      await sessionStorage.setItem('isMasterBuyer', response.resultObj?.data?.masterBuyerId);
      if (Cookies.get(constants.COOKIE_LOGGED_BUYER_ID) === buyerId) {
        await Cookies.set(constants.COOKIE_LOGGEDIN_IS_SUB_BUYER_ADMIN, response.resultObj?.data?.subBuyerAdmin)
      }
      const parserLinkVal = response.resultObj?.data?.parserLink || null;
      setIsJobtrainParser(parserLinkVal?.toLowerCase()?.includes('jobtrain') || false);
      const buyerName = response.resultObj?.data?.name || '';
      const isSchoolTalent = buyerName
        .toString()
        .toLowerCase()
        .includes('school talent');
      if (isSchoolTalent) {
        await sessionStorage.setItem('parserLink', 'schooltalent');
      } else if (parserLinkVal) {
        await sessionStorage.setItem('parserLink', parserLinkVal);
      } else {
        await sessionStorage.removeItem('parserLink');
      }
      window.dispatchEvent(new Event('parserLinkChanged'));
      setLoader(false);
    } else {
      setShowSubBuyerAdmin(false);
      setLoader(false);
    }
  };
  const instructionsItems= [
    {
      key: '1',
      label: 'Buy Credits',
      content: 
        <div className="space-y-4 leading-6">
          <ul className="list-disc pl-5 space-y-2">
            <li>
              First thing to do is to use the Top Up link at the top of the page or{" "}
              <Button
                type="link"
                onClick={() => setIsTopupOpen(true)}
                className="text-blue-600 hover:underline hover:text-blue-600 !p-0 !h-auto align-baseline"
              >Click Here</Button>{" "}
              to buy some credits which can be used to boost your jobs on
              Indeed, Linkedin, Job Boards and Social Media.
            </li>
            <li>
              Your Credit balance will be updated at the top of the page.
            </li>
          </ul>
      </div>
    },
    {
      key: '2',
      label: 'Boost Your Jobs',
      content:
        <div className="space-y-4 leading-6">
          <ol className="list-decimal pl-4 space-y-3">
            <li>Make sure you have some credits. If not then <Button
              type="link"
              onClick={() => setIsTopupOpen(true)}
              className="text-blue-600 hover:underline hover:text-blue-600 !p-0 !h-auto align-baseline"
            >
              Top Up
            </Button> your Credits.</li>
          <li>Go to Boost Your Jobs menu option and add the job(s) you want to boost to the Basket using the ‘add to basket’ buttons. </li>
          <li>View Basket and select which Indeed, LinkedIn and other job boards you would like to boost the job(s) onto. We will display all available boosting options, with recommended options shown first.</li>
          <li>Once you have selected them click the Buy Selected Products button and confirm the purchase.</li>
          <li>Your Order will now show in the Boost Orders tab and will be processed.</li>
          <li>The Boost Your Jobs page shows the Application count for each job that has come through our system and for more detailed reporting you can look at the Application Reports tab.</li>
        </ol>
      </div>
    },
    {
      key: '3',
      label: 'Social Media',
      content:
        <Tabs
          defaultActiveKey="setup"
          className="social-child-tabs"
          items={[
            {
              key: "setup",
              label: "Setup",
              children: (
                <div className="space-y-4 leading-6">
                  <ol className="list-decimal pl-4 space-y-3">
                    <li>Make sure you have some credits. If not then <Button
                      type="link"
                      onClick={() => setIsTopupOpen(true)}
                      className="text-blue-600 hover:underline hover:text-blue-600 !p-0 !h-auto align-baseline"
                    >Top Up</Button> your Credits.</li>
                    <li>Find the job you wish to promote on Facebook/Instagram.</li>
                    <li>Click Configure Ad and upload an image. You can also upload an MP4 video ad; however, if you add a video, please also upload an image, as this is required by the social media platforms.</li>
                    <li>Add in Promo text which will show with the ad.</li>
                    <li>Select either to send the Candidates to your Careers site URL (we cannot track these applications) or to the Apply Gateway application page (we can track these). It is usually recommended to send to the Careers site as it will convert better.</li>
                  </ol>
                </div>
              ),
            },
            {
              key: "tips",
              label: "Recommendations",
              children: (
                <div className="space-y-4 leading-6">
                  <ul className="list-disc pl-4 space-y-3">
                    <li>Include ‘We Are Hiring’ text in the image or video.</li>
                    <li>Images are best square and atleast 600px x 600px.</li>
                    <li>Do not include salary info in the ad Text as Facebook often bans those ads. You can mention great salary or similar.</li>
                    <li>Keep the ad text punchy and no more than 5 lines. The top 3 tend to be most visible.</li>
                  </ul>
                </div>
              ),
            },
          ]}
        />
    },
    {
      key: '4',
      label: 'Always On Suppliers',
      content:
        <div className="space-y-3 leading-6">
          <ul className="list-disc pl-5 space-y-2">
            <li>As part of Hire Intelligence we add in some free job board distribution for Organic applications.</li>
            <li>We also have some always on deals available where all jobs will be posted to the job board for an annual fee. Please reach out to us here to discuss these options.</li>
          </ul>
        </div>
    },
    {
      key: '5',
      label: 'Application Reports',
      content:
        <div className="space-y-3 leading-6">
          <ul className="list-disc pl-5 space-y-2">
            <li>Here you can analyse the performance of each of the Suppliers.</li>
            <li>
              The reports show data like the Number of Applies, Cost,
              Cost Per Apply, Interviews, Cost Per Interview, Offers,
              Cost Per Offer, Hires, Cost Per Hire.
            </li>
            <li>
              You can then evaluate the performance of each of the Boost
              Suppliers and use that to make informed decisions on your
              next boosts and get data on Cost Per Interview and Hire
              for your budget planning.
            </li>
          </ul>
        </div>
    },
    {
      key: '6',
      label: 'Support',
      content:
        <div className="space-y-3 leading-6">
          <ul className="list-disc pl-5 space-y-2">
            <li>Email help@hireintelligence.io or use the Support Chat Bot on the bottom right.</li>
          </ul>
        </div>
    },
  ];
  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      theme='light'
      className='lg:!bg-transparent !absolute lg:!relative top-0 z-40 h-screen lg:h-auto'
      width={255}
    >
      <Spin spinning={loader}>
      <div className='px-4 py-3 mb-4 bg-white rounded-md'>
        <div><label>Logged in as:</label></div>
        {/* <p className='mb-2.5'><strong>{Cookies.get(constants.COOKIE_LOGGED_BUYER_NAME)}</strong></p> */}
        <p className='mb-2.5'><strong>{getBuyerNameById( Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),Cookies.get(constants.COOKIE_LOGGED_BUYER_NAME))}</strong></p>
        <div><label>Showing Data For:</label></div>
        <Select
          showSearch
          placeholder="Select Buyer"
          dropdownStyle={{ width: 400 }}
          value={parseInt(buyerId)||undefined}
          className='w-full rounded-md border border-black'
          optionFilterProp="children"
          filterOption={(input, option) =>
            // console.log(
            //   "op",option
            // )
            // (option?.label ?? '').toLowerCase().includes(input.toLowerCase())||
            // (option?.Id??'').toLowerCase().includes(input.toLowerCase())
            option?.label?.toLowerCase()?.includes(input?.trim()?.toLowerCase()) ||
            option?.value?.toString()?.toLowerCase()?.includes(input?.trim()?.toLowerCase())
          }
          options={buyerList}
          onChange={(e) => BuyerChanged(e)}
        />
      </div>
      {visibleBuyerMenuItems.length > 0 ? (
        <Menu
          theme="light"
          mode="inline"
          className='rounded-md'
          selectedKeys={selectedMenuItem ? [selectedMenuItem.pageURL || selectedMenuItem.id] : []}
        >
          {visibleBuyerMenuItems
            .sort((a, b) => (a.menuOrder ?? 999) - (b.menuOrder ?? 999))
            .map((item) => (
              <Menu.Item key={item.pageURL || item.id} icon={getMenuItemIcon(item.menuIcon)}>
                <Link to={item.pageURL}>{item.menuText}</Link>
              </Menu.Item>
            ))}
        </Menu>
      ) : null}
      {showSelfServiceMenu && (
        <div className="mt-3">
          <Button
            type="primary"
            block
            style={{ textTransform: 'none' }}
            onClick={() =>
              setOpenPopover(
                openPopover === 'instructions'
                  ? null
                  : 'instructions'
              )
            }
          >
            <InfoCircleOutlined /> Instructions
          </Button>
          {openPopover === 'instructions' && (
            <div
              className="
                instruction-popup
                fixed
                bottom-2 sm:bottom-2 lg:bottom-2
                right-2 sm:right-4 lg:right-5
                w-[95vw]
                sm:w-[90vw]
                md:w-[680px]
                lg:w-[970px]
                z-[9999]
              "
            >
              <Card
                className="rounded-lg shadow-2xl border overflow-hidden"
                bodyStyle={{
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  height: "41vh",
                }}
              >
                <div className="flex items-center justify-between px-4 py-2 border-b text-white" style={{ backgroundColor: '#00B2A8' }}>
                  <div>
                    <h2 className="text-base font-semibold m-0 leading-5">
                      {constants.Instructions}
                    </h2>
                  </div>
                  <Button
                    type="text"
                    icon={<CloseOutlined />}
                    className='text-white'
                    onClick={() => setOpenPopover(null)}
                  />
                </div>
                <div className="px-4 py-3 overflow-hidden">
                  <Tabs
                    className="instruction-tabs"
                    tabPosition="left"
                    destroyInactiveTabPane
                    items={instructionsItems.map((tab) => ({
                      key: tab.key,
                      label: (
                        <span>
                          {tab.label}
                        </span>
                      ),
                      children: (
                        <div className="h-full overflow-y-auto">
                          <div className="bg-gray-50 border border-gray-100 rounded-lg p-2">
                            {tab.content}
                          </div>
                        </div>
                      ),
                    }))}
                  />
                </div>
              </Card>
            </div>
          )}
        </div>
      )}
            </Spin>
      {isTopupOpen &&
        <Topup
          open={isTopupOpen}
          setOpen={setIsTopupOpen}
      />}
    </Sider>
  );
};

export default Sidemenu;
